/**
 * Login Page Component
 * 
 * Shown when user is not authenticated.
 * Provides a button to redirect to Cognito Hosted UI.
 */

import { TrendingUp, LogIn, AlertCircle } from 'lucide-react';
import { useAuth } from './useAuth';

export function LoginPage() {
  const { login, error, isLoading } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="max-w-md w-full mx-4">
        {/* Logo Card */}
        <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 shadow-2xl">
          {/* Logo */}
          <div className="flex flex-col items-center mb-8">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-sky-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-sky-500/25 mb-4">
              <TrendingUp className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-slate-100">Portfolio Co-Pilot</h1>
            <p className="text-slate-400 mt-2 text-center">
              Investment Dashboard & MCP Integration
            </p>
          </div>

          {/* Error Message */}
          {error && (
            <div className="mb-6 p-4 bg-red-500/20 border border-red-500/30 rounded-xl flex items-start gap-3">
              <AlertCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-red-400 font-medium">Authentication Error</p>
                <p className="text-red-400/80 text-sm mt-1">{error}</p>
              </div>
            </div>
          )}

          {/* Login Button */}
          <button
            onClick={login}
            disabled={isLoading}
            className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-gradient-to-r from-sky-500 to-indigo-600 hover:from-sky-400 hover:to-indigo-500 text-white font-semibold rounded-xl shadow-lg shadow-sky-500/25 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Authenticating...
              </>
            ) : (
              <>
                <LogIn className="w-5 h-5" />
                Sign in with AWS Cognito
              </>
            )}
          </button>

          {/* Info */}
          <p className="mt-6 text-center text-sm text-slate-500">
            Secure authentication powered by AWS Cognito
          </p>
        </div>

        {/* Footer */}
        <p className="mt-8 text-center text-sm text-slate-600">
          Portfolio Co-Pilot • Secure • Local-first
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
